/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceType = exports.Reason = exports.NotificationType = exports.Handler = exports.BusinessNotificationType = void 0;
var BusinessNotificationType;
(function (BusinessNotificationType) {
    BusinessNotificationType["UNDEFINED"] = "UNDEFINED";
    BusinessNotificationType["CONFIRMATION_EMAIL"] = "CONFIRMATION_EMAIL";
})(BusinessNotificationType = exports.BusinessNotificationType || (exports.BusinessNotificationType = {}));
var Handler;
(function (Handler) {
    Handler["UNDEFINED"] = "UNDEFINED";
    Handler["REMINDERS"] = "REMINDERS";
    Handler["ACTIVITY"] = "ACTIVITY";
    Handler["ALL"] = "ALL";
    Handler["OWNER_EMAILS"] = "OWNER_EMAILS";
    Handler["VISITOR_EMAILS"] = "VISITOR_EMAILS";
})(Handler = exports.Handler || (exports.Handler = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["UNDEFINED"] = "UNDEFINED";
    NotificationType["CONFIRMATION_EMAIL"] = "CONFIRMATION_EMAIL";
    NotificationType["CANCELLATION_EMAIL"] = "CANCELLATION_EMAIL";
    NotificationType["REMINDER_EMAIL"] = "REMINDER_EMAIL";
    NotificationType["REMINDER_SMS"] = "REMINDER_SMS";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var Reason;
(function (Reason) {
    Reason["UNKNOWN"] = "UNKNOWN";
    Reason["PageNotInstalled"] = "PageNotInstalled";
    Reason["NoPlansAssignedToOffering"] = "NoPlansAssignedToOffering";
})(Reason = exports.Reason || (exports.Reason = {}));
var ServiceType;
(function (ServiceType) {
    ServiceType["UNKNOWN_SERVICE_TYPE"] = "UNKNOWN_SERVICE_TYPE";
    ServiceType["APPOINTMENT"] = "APPOINTMENT";
    ServiceType["CLASS"] = "CLASS";
    ServiceType["COURSE"] = "COURSE";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
//# sourceMappingURL=types.js.map